module.exports = __webpack_public_path__ + "feedback.ff2a338ced61e692a2f3abe7f770830b.svg";